import { BestPerformingInfluencer } from '../../../../../models/measure/report';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { BestPerformingInfluencerComponent } from '../best-performing-influencer.component';
import { Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';
var TopPerformingInfluencerComponent = /** @class */ (function () {
    function TopPerformingInfluencerComponent(pdfService, router, userService) {
        this.pdfService = pdfService;
        this.router = router;
        this.userService = userService;
    }
    TopPerformingInfluencerComponent.prototype.getImpactValue = function (value) {
        return value * 100;
    };
    TopPerformingInfluencerComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded(BestPerformingInfluencerComponent.COMPONENT_NAME);
    };
    Object.defineProperty(TopPerformingInfluencerComponent.prototype, "countryCode", {
        get: function () {
            if (!this.topPerforming || !this.topPerforming.country || !this.topPerforming.country.code) {
                return null;
            }
            return this.topPerforming.country.code.toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    TopPerformingInfluencerComponent.prototype.openInfluencerDetails = function () {
        return this.router.navigate(["/influencer/" + this.topPerforming.influencerId + "/overview"], {
            queryParams: {
                activeAccount: this.userService.getCompanyId()
            }
        });
    };
    return TopPerformingInfluencerComponent;
}());
export { TopPerformingInfluencerComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/top-performing-influencer/top-performing-influencer.component.ts.pre-build-optimizer.js